import { render } from "./AlertPanel.vue?vue&type=template&id=5a89d50c&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=js"
export * from "./AlertPanel.vue?vue&type=script&lang=js"

import "./AlertPanel.vue?vue&type=style&index=0&id=5a89d50c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a89d50c"]])

export default __exports__